import { render, staticRenderFns } from "./habilitacion.vue?vue&type=template&id=1347b808"
import script from "./habilitacion.vue?vue&type=script&lang=js"
export * from "./habilitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports